"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _pubsub = require("./pubsub");
var useSubscriber = function useSubscriber(subscribingEvent, eventHandlerMapping) {
  (0, _react.useLayoutEffect)(function () {
    var eventSubscriber = function eventSubscriber(msg, data) {
      var trackingFn = eventHandlerMapping[msg];
      trackingFn && trackingFn(data);
    };
    var token = (0, _pubsub.subscribe)(subscribingEvent, eventSubscriber);
    return function () {
      (0, _pubsub.unsubscribe)(token);
    };
  }, [eventHandlerMapping, subscribingEvent]);
};
var _default = useSubscriber;
exports["default"] = _default;